import InterviewClient from './InterviewClient';
import { AudioPlayer } from './Audio';
import '../css/styles.css';

class App {
	config;
	audioPlayer;

	constructor( config ) {
		this.config = this.settings = this.parseConfig( config );
		this.interview = new InterviewClient( this.config, this );
	}

	async init() {
		const config = this.config;
		if ( config.audio || config.interview ) {
			await this.initAudio();
		}
	
		if ( config.audio ) {
			//const useClick = config.audio && config.talk_trigger;
			await this.playAudio( config );
		} else if ( config.interview ) {
			await this.interview.init( this );
		}

		if ( config.talk_trigger ) {
			this.interview.hotkeyListener( config.talk_trigger );
		}

		if ( config.redirect ) {

			if ( config.redirect_delay ) {
				console.log( 'Setting redirect timer' );
				setTimeout( () => { location.href = config.redirect }, config.redirect_delay );
			} else {
				location.href = config.redirect;
				return;
			}
		}

	}

	parseConfig( settings ) {
		const defaults = {
			audioinit: false,
			interview: null,
			start: false,
			audio: null,
			after_audio: null,
			talk_trigger: null,
			redirect: null,
			redirect_delay: null
		};

		const config = {};

		for( const prop in defaults ) {
			config[prop] = ( prop in settings ) ? settings[prop] : defaults[prop];
		}

		return config;
	}

	async playAudio( config, useClick ) {
		//const audio = new Audio( config.audio );
		//this.audioPlayer = new AudioPlayer();
		const audio = this.interview.audioPlayer.audio;

		try {
			await this.interview.audioPlayer.init( config.audio );
		} catch (e) {
			this.showAudioModal( this.interview.audioPlayer );
		}

		if ( config.after_audio ) {
			audio.addEventListener( 'ended', () => {
				location.href = config.after_audio;
			});
		}

	}

	async initAudio() {
		this.mic = await navigator.mediaDevices.getUserMedia({ audio: true });

		const player = new AudioPlayer();
		this.audioPlayer = player;
		try {
			await player.init();
		} catch( e ) {
			console.error('initAudio', e);
			await this.showAudioModal( player );
		}
	}

	audioModal() {
		let dialog = document.querySelector( '#talk_notice' );

		if ( !dialog ) {
			dialog = document.createElement( 'dialog' );
			dialog.id = 'talk_notice';
			const txt = document.createElement( 'p' );
			dialog.appendChild( txt );
			document.body.appendChild( dialog );
		}

		const message = 'Click to continue';
		dialog.querySelector('p').textContent = message;
		return dialog;
	}

	showAudioModal( player ) {
		return new Promise( resolve => {
			const dialog = this.audioModal();
			
			const closeModal = () => {
				removeListeners();
				dialog && dialog.close();
				resolve( player.audio.play() );
			};

			const hotkeyHandler = (e) => {
				if ( e.code === keycode ) {
					e.preventDefault();
					if ( e.repeat ) { return; }
					closeModal();
				}
			}

			const removeListeners = () => {
				dialog.removeEventListener( 'click', closeModal );
				document.removeEventListener( 'keydown', hotkeyHandler );
			}

			dialog.addEventListener( 'click', closeModal );
			document.addEventListener( 'keydown', hotkeyHandler );

			dialog && dialog.showModal();
		});
	}

}

document.addEventListener('DOMContentLoaded', () => {
	const app = new App( global.synapse_settings || {} ); //NOSONAR
	app.init();
});

